import { MenuItemType } from '@/modules/common/layout/models/types/MenuItem'
import route from 'ziggy-js'
import { isDef } from '@vueuse/core'
import { UserBootUseCase } from '@/modules/user/use-cases/shared/user-boot.use-case'

export function adminMenuStoreItems(userBootUseCase: UserBootUseCase): Array<MenuItemType> {
  let items = [
    {
      id: 'dashboard',
      name: 'داشبورد',
      icon: 'ion grid-outline',
      regex: '^/admin.*$',
      path: route('admin.dashboard')
    },
    userBootUseCase.ifCan('contentItem-viewAny',
      {
        id: 'content-items',
        name: 'مقالات',
        icon: 'ion file-tray-full-outline',
        regex: '^/admin/content/items(\/)?(.*)$',
        path: route('admin.content.items.index')
      }),
    userBootUseCase.ifCan('contentCampaign-viewAny',
      {
        id: 'content-campaigns',
        name: 'کمپین ها',
        icon: 'ion file-tray-stacked-outline',
        regex: '^/admin/content/campaigns(\/)?(.*)$',
        path: route('admin.content.campaigns.index')
      }),
    userBootUseCase.ifCan('contentCampaign-viewAny',
      {
        id: 'content-statistics',
        name: 'آمار نگارش',
        icon: 'ion document-text-outline',
        regex: '^/admin/content/statistics(\/)?(.*)$',
        path: route('admin.content.statistics.index')
      }),
    userBootUseCase.ifCan('', {
      id: 'support',
      name: 'پشتیبانی',
      icon: 'ion help-buoy-outline',
      path: route('admin.vip-groups.index'),
      regex: '^/admin/supports.*$',
      children: [
        userBootUseCase.ifCan('ticket-viewAny', {
          id: 'tickets',
          name: 'تیکت ها',
          regex: '^/admin/supports/tickets(\/)?(.*)$',
          path: route('admin.support.tickets.index')
        }),
        userBootUseCase.ifCan('department-viewAny', {
          id: 'department',
          name: 'دپارتمان‌ها',
          regex: '^/admin/supports/departments(\/)?(.*)$',
          path: route('admin.support.departments.index')
        }),
        userBootUseCase.ifCan('predefinedAnswer-viewAny', {
          id: 'predefined_answers',
          name: 'پاسخ های آماده',
          regex: '^/admin/supports/predefined-answers(\/)?(.*)$',
          path: route('admin.support.predefined-answers.index')
        }),
        {
          id: 'news',
          name: 'اخبار',
          regex: '^/admin/supports/latest-news(\/)?(.*)$',
          path: route('admin.support.latest-news.index')
        },
        userBootUseCase.ifCan('faq-viewAny', {
          id: 'faq',
          name: 'سوالات متداول',
          regex: '^/admin/supports/faqs(\/)?(.*)$',
          path: route('admin.support.faqs.index')
        })
      ]
    }),
    userBootUseCase.ifCan('', {
      id: 'financial',
      name: 'مالی',
      icon: 'ion cash-outline',
      regex: '^/admin/financial.*$',
      path: route('admin.vip-groups.index'),
      children: [
        userBootUseCase.ifCan('deposit-viewAny', {
          id: 'deposits',
          name: 'واریزی ها',
          regex: '^/admin/financial/deposits(\/)?(.*)$',
          path: route('admin.financial.deposits.index')
        }),
        userBootUseCase.ifCan('invoice-viewAny', {
          id: 'invoices',
          name: 'فاکتورها',
          regex: '^/admin/financial/invoices(\/)?(.*)$',
          path: route('admin.financial.invoices.index')
        }),
        userBootUseCase.ifCan('coupon-viewAny', {
          id: 'coupons',
          name: 'کوپن‌ها تخفیف',
          regex: '^/admin/financial/coupons(\/)?(.*)$',
          path: route('admin.financial.coupons.index')
        }),
        userBootUseCase.ifCan('transaction-viewAny', {
          id: 'transactions',
          name: 'تراکنش ها',
          regex: '^/admin/financial/transactions(\/)?(.*)$',
          path: route('admin.financial.transactions.index')
        }),
        userBootUseCase.ifCan('depositBankAccount-viewAny', {
          id: 'depositBankAccounts',
          name: 'حساب‌های شرکت',
          regex: '^/admin/financial/deposit-bank-accounts(\/)?(.*)$',
          path: route('admin.financial.deposit-bank-accounts.index')
        })
      ]
    }),
    userBootUseCase.ifCanAny(['profit-viewAny', 'campaignItemPayment-viewAny'], {
      id: 'statistics',
      name: 'آمار',
      icon: 'ion stats-chart-outline',
      regex: '^/admin/statistics.*$',
      path: '',
      children: [
        userBootUseCase.ifCan('profit-viewAny', {
          id: 'profit',
          name: 'سودها',
          regex: '^/admin/statistics/profits(\/)?(.*)$',
          path: route('admin.statistics.profits.index')
        })
        // userBootUseCase.ifCan('campaignItemPayment-viewAny', {
        //   id: 'payments',
        //   name: 'تسویه حساب ها',
        //   regex: '^/admin/statistics/campaign-item-payments(\/)?(.*)$',
        //   path: route('admin.statistics.campaign-item-payments.index')
        // })
      ]
    }),
    userBootUseCase.ifCan('', {
      id: 'users',
      name: 'کاربران',
      icon: 'ion people-outline',
      path: route('admin.users.index'),
      children: [
        userBootUseCase.ifCan('user-viewAny', {
          id: 'users-list',
          name: 'لیست کابران',
          regex: '^/admin/users.*$',
          path: route('admin.users.index')
        }),
        userBootUseCase.ifCan('vipGroup-viewAny', {
          id: 'vip-group',
          name: 'گروه های ویژه',
          regex: '^/admin/vip-groups.*$',
          path: route('admin.vip-groups.index')
        })
      ]
    }),
    userBootUseCase.ifHasRole(['superadmin', 'manager'], {
        id: 'settings',
        name: 'تنظیمات',
        icon: 'ion settings-outline',
        children: [
          {
            id: 'preferences',
            name: 'تنظیمات اعلانات',
            regex: '^/admin/preferences.*$',
            path: route('admin.preferences.index')
          }
        ]
      }
    )
  ]

  return items.filter(item => item !== null)
    .map(item => ({ ...item, children: item.children?.filter(isDef) }))
}
